import { render, staticRenderFns } from "./totalOfCommission.vue?vue&type=template&id=69608e92&scoped=true"
import script from "./totalOfCommission.vue?vue&type=script&lang=js"
export * from "./totalOfCommission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69608e92",
  null
  
)

export default component.exports